import Image1 from "../assets/ledgerview.PNG";
import Image2 from "./heroorphanage.JPG";
import Image3 from "./techlandingpage.JPG";
import Image4 from "./awaritse.PNG";
import Image5 from "../assets/twitter clone.JPG";
import Image6 from "../assets/AngularBusTicketing.PNG";

const Work = [
  {
    id: 1,
    name: "LegderView Fintech Dashboard",
    description:
      "This is Fintech dashboard web application for a client. It displays various financial data in form of charts and graphs. It is built using React.js and Typescript.",
    image: Image1,
    link: "https://fintech-dashboard-sand.vercel.app/",
    techStack: "React.js | Typescript | Recharts | CSS",
    githubLink: "https://github.com/summyalena/fintech-dashboard",
  },
  
  {
    id: 2,
    name: "Bus Ticketing App",
    description:
      "This is a bus ticketing app that allows users to book bus tickets online. It has features like bus schedule, seat selection. Built with Angular and SCSS.",
    image: Image6,
    link: "https://bus-ticketing-app-by5y.vercel.app/search",
    techStack: "Angular | SCSS",
    githubLink: "https://github.com/summyalena/bus-ticketing-app",
  },
  {
    id: 3,
    name: "Twitter Clone",
    description:
      "Twitter-clone is a web app that is a replica of the UI of twitter social media web app. I added some basic functionalities like comments, posting and liking a post. Built with Next.js, tailwind CSS, Next Authentication and firebase database. ",
    image: Image5,
    link: "https://twitter-clone-alena.vercel.app/",
    techStack: "Next.js | Tailwind CSS | Firebase ",
    githubLink: "https://github.com/summyalena/Twitter-clone",
  },
  // {
  //   id: 3,
  //   name: 'Afrobean Shopping Website',
  //   description: 'This is a shopping website for agricultural Products',
  //   image: Image1,
  //   link: "https://afro-bean.vercel.app/",
  //   techStack: "Reactjs | Typescript | Vanilla CSS | Tailwind CSS",
  //   githubLink: "Private Repo"
  // },

  {
    id: 4,
    name: "Awaritse Limited Website",
    description:
      "This is a website that displays the information of a client's company. It also has a admin dashboard that stores their blog data and manages it. It is built in Typescript",
    image: Image4,
    link: "https://awaritse-client.vercel.app/",
    techStack: "Typescript | CSS | React js | Tailwind CSS",
    githubLink: "https://github.com/DuaneDave/Awaritse-client",
  },

  {
    id: 5,
    name: "Orphanage Home",
    description:
      "This is a website created to shares awareness of an orphanage home in Enugu city",
    image: Image2,
    link: " https://orphanage.vercel.app",
    techStack: "Javascript | Next.js | CSS ",
    githubLink: "https://github.com/summyalena/Orphanage",
  },

  {
    id: 6,
    name: "Webxiel Landing page",
    description:
      "This is a website created to show the profile of a new tech startup in Nigeria",
    image: Image3,
    link: "https://webxiel-testwork67.vercel.app",
    techStack: "Javascript | React | Vanilla CSS ",
    githubLink: "https://github.com/summyalena/webxiel_testwork67",
  },
];

export default Work;
